import {Component} from 'react';
import { connect } from 'react-redux';
import { get_global_stats_counter } from '../../utils/data';
import Counters from '../Counters/Counters';

import './GlobalStats.css';

interface Props{
    data:any

    className?:string
}
interface State{
}


export default connect((state:any)=>{
    return { data: state.data }
})(class GlobalStats extends Component<Props,State>{
    render(){
        return (
            <Counters
                className={this.props.className}
                counters={[                    
                    get_global_stats_counter("PRODUCTS DATA", "Peta bytes", this.props.data.global_stats_data?.size, this.props.data?.loading_global_stats),
                    get_global_stats_counter("MISSIONS", undefined, this.props.data.global_stats_data?.n_mission, this.props.data?.loading_global_stats),
                    get_global_stats_counter("DATASETS", undefined, this.props.data.global_stats_data?.n_ingested_dataset, this.props.data?.loading_global_stats),
                    get_global_stats_counter("PRODUCTS", "Million", this.props.data.global_stats_data?.n_prod, this.props.data?.loading_global_stats),
                ]}
            />
        );
    }

});